"use client";

import type { ToasterProps } from "sonner";

import { Toaster as BaseToaster } from "@/components/base-ui/sonner";

// richColors: sonner's default renders every toast in neutral popover colors,
// so an error toast is gray text on a white card — barely legible, especially
// behind a dialog's dimming overlay. richColors gives error/success/warning
// toasts their semantic background and text colors app-wide (both the [lang]
// and admin layouts mount this component).
const Toaster = (props: ToasterProps) => <BaseToaster richColors {...props} />;

export { Toaster };
